import { Button } from "@/components/ui/button";
import { Phone, ArrowDown } from "lucide-react";

interface InlineCTAProps {
  heading?: string;
  highlightedHeading?: string;
  description?: string;
}

export function InlineCTA({
  heading = "Ready to",
  highlightedHeading = "Get Started?",
  description = "Call or text us directly or scroll down to request your free estimate.",
}: InlineCTAProps) {
  return (
    <section className="py-16 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="text-2xl md:text-3xl font-bold">
            {heading} <span className="text-gradient-gold">{highlightedHeading}</span>
          </h2>
          <p className="text-muted-foreground text-lg">{description}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="goldOutline" size="lg" asChild>
              <a href="tel:+19737252395" className="flex items-center gap-2">
                <Phone className="h-5 w-5" />
                Call or Text (973) 725-2395
              </a>
            </Button>
            <Button variant="gold" size="lg" asChild>
              <a href="#contact" className="flex items-center gap-2">
                <ArrowDown className="h-5 w-5" />
                Get Your Free Estimate
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
